Controller = require 'controller'
React = require 'react'
t = require('views/internal/recup-with-helpers')('member_billing_org_link_list')

module.exports = class extends React.Component
  displayName: 'MemberBillingOrgLinkListComponent'

  canViewBillingPage: (org) ->
    org.owned() && org.isPremium() && !org.paysWithPurchaseOrder()

  getOrgDisplayData: (org) ->
    billingLink: Controller.getOrganizationBillingUrl(org)
    displayName: org.get('displayName')

  render: t.renderable ->
    { organizationList } = @props

    orgsDisplayData = organizationList.filter(@canViewBillingPage)
                                      .map(@getOrgDisplayData)

    if orgsDisplayData.length == 0
      return t.div()

    t.div ->
      t.div { style: { maxWidth: '450px', marginTop: '32px' } }, ->
        t.h3 ->
          t.format 'looking-for-your-organization-s-billing-page'

        t.ul '.js-org-link-list', ->
          orgsDisplayData.map ({ billingLink, displayName }) ->
            t.li ->
              t.a { href: billingLink }, ->
                t.format 'displayname-billing-page', { displayName }



// WEBPACK FOOTER //
// ./app/scripts/views/billing/member-billing-org-link-list-component.coffee